import React from 'react';
import {
  ExpandableMenu,
  MenuItem,
  MenuList,
  MenuButton,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import { ExpandableButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';
import Tokens from '@grnhse/seedling/lib/birch/tokens';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';

const t = withLocalePrefix('talent_matching.bulk_actions.menu');

type Props = {
  openSendEmailModal: () => void;
  openAddTagsModal: () => void;
  openRejectModal: () => void;
  openFraudReportModal: () => void;
  canReject: boolean;
  canEmail: boolean;
  canRunFraudReports: boolean;
  openInAppReview: () => void;
};

const DangerMenuItem = styled(MenuItem)`
  &&&& {
    color: ${Tokens.colors.error};
  }
`;

const Menu = ({
  openSendEmailModal,
  openAddTagsModal,
  openRejectModal,
  openFraudReportModal,
  canReject,
  canEmail,
  canRunFraudReports,
  openInAppReview,
}: Props) => {
  return (
    <ExpandableMenu>
      <ExpandableButton as={MenuButton} size="md">
        {t('title')}
      </ExpandableButton>
      <MenuList>
        {canEmail ? (
          <MenuItem onSelect={openSendEmailModal}>{t('send_email')}</MenuItem>
        ) : (
          <Tooltip
            label={t('tooltips.cannot_email')}
            ariaLabel={t('tooltips.cannot_email')}
          >
            <MenuItem onSelect={openSendEmailModal} disabled={true}>
              {t('send_email')}
            </MenuItem>
          </Tooltip>
        )}

        <MenuItem onSelect={openAddTagsModal}>{t('add_tags')}</MenuItem>
        {canReject ? (
          <DangerMenuItem onSelect={openRejectModal}>
            {t('reject_as_spam')}
          </DangerMenuItem>
        ) : (
          <Tooltip
            label={t('tooltips.cannot_reject')}
            ariaLabel={t('tooltips.cannot_reject')}
          >
            <DangerMenuItem onSelect={openRejectModal} disabled={true}>
              {t('reject_as_spam')}
            </DangerMenuItem>
          </Tooltip>
        )}
        <MenuItem onSelect={openInAppReview}>
          {t('application_review')}
        </MenuItem>
        {canRunFraudReports && (
          <MenuItem onSelect={openFraudReportModal}>
            {t('run_fraud_reports')}
          </MenuItem>
        )}
      </MenuList>
    </ExpandableMenu>
  );
};

export default Menu;
